import { PlottingColorByEnum } from "@/app/(internal)/panel/(maps)/_enums/plotting-filters.enum";
import { StudentCountsInShapeColorByEnum } from "@/providers/store/api/shapes/enums/student-counts-in-shape.enum";

export function toStudentCountsColorBy(
  plottingColorBy: PlottingColorByEnum,
): StudentCountsInShapeColorByEnum {
  if (plottingColorBy === PlottingColorByEnum.SCHOOL) {
    return StudentCountsInShapeColorByEnum.SCHOOL;
  }

  if (plottingColorBy === PlottingColorByEnum.GRADE) {
    return StudentCountsInShapeColorByEnum.GRADE;
  }

  return StudentCountsInShapeColorByEnum.NONE;
}
